export const calendarPhoto =
  "https://firebasestorage.googleapis.com/v0/b/psi-works-backoffice.appspot.com/o/website%2Fmain%2Fcalendar.jpg?alt=media&token=e0c7558e-7896-4ec3-8005-56b26e49906e";
export const medicalDoc =
  "https://firebasestorage.googleapis.com/v0/b/psi-works-backoffice.appspot.com/o/website%2Fmain%2Fmedical-doc.jpg?alt=media&token=9cd88d38-e290-431f-b0d6-abd914b945e4";
export const appointmentHistory =
  "https://firebasestorage.googleapis.com/v0/b/psi-works-backoffice.appspot.com/o/website%2Fmain%2Fappointment-history.jpg?alt=media&token=2ba3da47-72fb-4576-82fb-696891aa59fb";
